import PlaceholderPerson from './PlaceholderPerson';

export default PlaceholderPerson;
